import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { CompanyForm } from "./CompanyForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface ICompanyCreateProps {}

export const CompanyCreate = (props: ICompanyCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Company,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-companies.title.create">
        <CompanyForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
